/* SL · Vittoria sobre Horizon — tarjetas con 2 botones, Comprar ahora, Arma tu set, combos por WhatsApp — SodaLab */
import { CartLinesUpdateEvent } from '@shopify/events';

const C = window.__SL || {};
const CED = C.ced || 'Cédula';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const okCed = (v) => /^\d{6,10}$/.test(String(v || ''));
const JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };

/* ---------- dinero con el formato de la tienda ---------- */
function money(cents) {
  const f = C.mf || '${{amount_no_decimals}}';
  const n = Math.round(Number(cents) || 0);
  const grp = (x, sep) => String(x).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
    const u = Math.round(n / 100);
    if (k === 'amount_no_decimals') return grp(u, ',');
    if (k === 'amount_no_decimals_with_comma_separator') return grp(u, '.');
    if (k === 'amount_with_comma_separator') return grp(Math.floor(n / 100), '.') + ',' + String(n % 100).padStart(2, '0');
    return grp(Math.floor(n / 100), ',') + '.' + String(n % 100).padStart(2, '0');
  });
}

/* ---------- cédula ---------- */
let ced = '';
let cedP = null;
let saveT = null;
let saveP = Promise.resolve();
function loadCed() {
  if (!cedP) {
    cedP = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => (ced = String((c.attributes || {})[CED] || '').replace(/\D/g, '').slice(0, 10)))
      .catch(() => ced);
  }
  return cedP;
}
function saveCed(v) {
  const a = {};
  a[CED] = v;
  saveP = fetch('/cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ attributes: a }) }).catch(() => {});
  return saveP;
}
let cedN = 0;
function injectCed() {
  $$('button[name="checkout"]').forEach((b) => {
    const host = b.parentElement;
    if (!host || host.querySelector('.sl-ced')) return;
    const id = 'slCed' + ++cedN;
    const box = document.createElement('div');
    box.className = 'sl-ced';
    box.innerHTML =
      '<label class="sl-ced__l" for="' + id + '">Cédula <span>(obligatoria para tu factura y envío)</span></label>' +
      '<input id="' + id + '" class="sl-ced__i" type="text" inputmode="numeric" autocomplete="off" maxlength="10" placeholder="Número de cédula">' +
      '<p class="sl-ced__e">Ingresa tu cédula (6 a 10 dígitos) para finalizar la compra.</p>';
    host.insertBefore(box, b);
    const i = box.querySelector('input');
    i.value = ced;
    box.classList.toggle('is-ok', okCed(ced));
    i.addEventListener('input', () => {
      i.value = i.value.replace(/\D/g, '').slice(0, 10);
      ced = i.value;
      const good = okCed(ced);
      box.classList.toggle('is-ok', good);
      if (good) box.classList.remove('is-err', 'is-need');
      clearTimeout(saveT);
      saveT = setTimeout(() => saveCed(ced), 400);
    });
  });
}
async function toCheckout(btn) {
  const box = btn && btn.parentElement ? btn.parentElement.querySelector('.sl-ced') : null;
  const v = box ? box.querySelector('input').value : ced;
  if (!okCed(v)) {
    if (box) {
      box.classList.add('is-err');
      const i = box.querySelector('input');
      i.focus();
      i.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return;
  }
  clearTimeout(saveT);
  if (btn) btn.classList.add('sl-busy');
  await saveCed(v);
  location.href = '/checkout';
}
/* 22-oct: la cédula ya no se pide en el carrito (se pide en el checkout, campo Empresa). El botón Pagar queda nativo. */

/* ---------- carrito ---------- */
function openDrawer() {
  const d = document.getElementById('cart-drawer');
  if (d && typeof d.open === 'function') {
    if (!d.isOpen) d.open();
  } else location.href = '/cart';
}
function needCed() {
  const qa = document.getElementById('quick-add-dialog');
  const qaOpen = !!(qa && qa.querySelector('dialog[open]'));
  if (qaOpen && typeof qa.closeDialog === 'function') qa.closeDialog();
  setTimeout(openDrawer, qaOpen ? 300 : 0);
  let n = 0;
  (function w() {
    const i = $('#cart-drawer .sl-ced input') || $('.sl-ced input');
    if (i) {
      const box = i.closest('.sl-ced');
      box.classList.add('is-need');
      setTimeout(() => {
        i.focus();
        i.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 350);
      return;
    }
    if (++n < 40) setTimeout(w, 150);
  })();
}
async function goCheckout() {
  location.href = '/checkout';
}
export async function addLines(lines) {
  const d = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: l.id, quantity: l.quantity })),
      promise: d.promise,
    })
  );
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: lines }) });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar');
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
    d.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: j.items, itemCount: cart.item_count, source: 'sl', didError: false },
    });
    return cart;
  } catch (err) {
    d.reject(err);
    throw err;
  }
}

/* intención: "buy" = después de agregar, ir a pagar (pidiendo cédula si falta) */
let intent = null;
function setIntent(v) {
  intent = v;
  if (v) document.documentElement.setAttribute('data-sl-intent', v);
  else document.documentElement.removeAttribute('data-sl-intent');
}
document.addEventListener(CartLinesUpdateEvent.eventName, (e) => {
  if (e.action !== 'add') return;
  const buy = intent === 'buy';
  setIntent(null);
  if (!buy) return;
  if (e.promise)
    e.promise
      .then((r) => {
        if (r && r.detail && r.detail.didError) return;
        setTimeout(goCheckout, 120);
      })
      .catch(() => {});
});
document.addEventListener(
  'close',
  (e) => {
    if (e.target && e.target.tagName === 'DIALOG' && !e.target.closest('#cart-drawer')) setTimeout(() => setIntent(null), 400);
  },
  true
);

/* ---------- WhatsApp (combos) ---------- */
const WA_ICON =
  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.79h-.01a9.870 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.440 9.88-9.88 9.88m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89a11.82 11.82 0 0 0-3.48-8.41z"/></svg>';
function waBtn(p, h, lg) {
  const a = document.createElement('a');
  a.className = 'slw-btn' + (lg ? ' slw-btn--lg' : '');
  const msg = 'Hola VITTORIA, quiero comprar el ' + p.t + (p.m ? ' (' + p.m + ')' : '') + ': ' + location.origin + '/products/' + h;
  a.href = 'https://wa.me/' + C.wa + '?text=' + encodeURIComponent(msg);
  a.target = '_blank';
  a.rel = 'noopener';
  a.innerHTML = WA_ICON + '<span class="slw-l">Comprar por WhatsApp</span><span class="slw-s">Pedir</span>';
  a.addEventListener('click', (e) => {
    e.stopPropagation();
    try {
      (window.dataLayer = window.dataLayer || []).push({ event: 'whatsapp_click', product_name: p.t });
    } catch (x) {}
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Contact', { content_name: p.t });
    } catch (x) {}
  });
  return a;
}
const handleOf = (u) => {
  const m = /\/products\/([^/?#]+)/.exec(u || '');
  return m ? decodeURIComponent(m[1]) : '';
};

/* ---------- tarjetas de producto ---------- */
function cards() {
  $$('product-card').forEach((c) => {
    if (c.dataset.sl) return;
    const link = c.querySelector('a[href*="/products/"]');
    const h = handleOf(link && link.getAttribute('href'));
    const content = c.querySelector('.product-card__content') || c;
    const combo = C.combos && C.combos[h];
    c.dataset.sl = '1';
    const box = document.createElement('div');
    box.className = 'sl-cta';
    if (combo) {
      c.classList.add('sl-card--wa');
      box.appendChild(waBtn(combo, h, false));
    } else if (/^pack-/.test(h)) {
      /* Packs VITTORIA SALE: una sola talla para todo el pack; se elige en la PDP (ahí está la nota) */
      box.innerHTML = '<a class="sl-b sl-b--buy sl-b--go" style="display:flex;align-items:center;justify-content:center;text-decoration:none" href="/products/' + h + '">Elegir mi talla</a>';
      /* sello VITTORIA SALE -X% sobre la foto */
      const bd = c.querySelector('.product-badges__badge');
      if (bd) {
        const num = (s) => parseInt(String(s || '').replace(/\D/g, ''), 10) || 0;
        const pr = c.querySelector('product-price, .price');
        const now = num(pr && (pr.querySelector('.price') || pr).textContent.split(/\s+/).find((t) => /\d/.test(t)));
        const was = num(c.querySelector('.compare-at-price') && c.querySelector('.compare-at-price').textContent);
        const pct = now && was > now ? Math.round(((was - now) * 100) / was) : 0;
        bd.textContent = 'VITTORIA SALE' + (pct ? ' -' + pct + '%' : '');
        bd.classList.add('sl-sale-badge');
        bd.style.setProperty('background', '#8c1d2e', 'important');
        bd.style.setProperty('color', '#fff', 'important');
        bd.style.setProperty('border-color', '#8c1d2e', 'important');
      }
    } else {
      const nat = c.querySelector('quick-add-component button');
      if (!nat || nat.disabled) return;
      box.innerHTML =
        '<button type="button" class="sl-b sl-b--buy">Comprar ahora</button>' +
        '<button type="button" class="sl-b sl-b--add">Agregar a la bolsa</button>';
    }
    content.appendChild(box);
  });
}
document.addEventListener(
  'click',
  (e) => {
    const b = e.target.closest && e.target.closest('.sl-cta .sl-b');
    if (!b || b.tagName === 'A') return;
    e.preventDefault();
    e.stopPropagation();
    const card = b.closest('product-card');
    const nat = card && card.querySelector('quick-add-component button');
    if (!nat) return;
    setIntent(b.classList.contains('sl-b--buy') ? 'buy' : 'add');
    nat.click();
  },
  true
);

/* ---------- formularios de producto (PDP y compra rápida) ---------- */
function isComboRoot(el) {
  const pf = el.closest('product-form-component') || el;
  const url = pf.getAttribute('data-product-url') || '';
  return !!(C.combos && C.combos[handleOf(url)]);
}
function forms() {
  $$('product-form-component').forEach((pf) => {
    const atc = pf.querySelector('add-to-cart-component');
    if (!atc) return;
    if (isComboRoot(pf)) {
      pdpWa(pf);
      return;
    }
    if (!pf.querySelector('.sl-now')) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sl-now button';
      b.textContent = 'Comprar ahora';
      const holder = atc.parentElement && atc.parentElement.tagName === 'SPAN' ? atc.parentElement : atc;
      holder.insertAdjacentElement('afterend', b);
    }
    $$('.add-to-cart-button', pf).forEach(relabel);
  });
}
function relabel(btn) {
  const w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
  let n;
  while ((n = w.nextNode())) {
    if (/agregar al carrito|a[nñ]adir al carrito/i.test(n.textContent))
      n.textContent = n.textContent.replace(/agregar al carrito|a[nñ]adir al carrito/i, 'Agregar a la bolsa');
  }
}
document.addEventListener(
  'click',
  (e) => {
    const b = e.target.closest && e.target.closest('.sl-now');
    if (!b) return;
    e.preventDefault();
    const pf = b.closest('product-form-component');
    const atcBtn = pf && pf.querySelector('add-to-cart-component button');
    if (!atcBtn || atcBtn.disabled) return;
    setIntent('buy');
    atcBtn.click();
  },
  true
);
function pdpWa(pf) {
  const host = pf.closest('.buy-buttons-block') || pf;
  if (host.parentElement.querySelector('.slw-pdp')) return;
  document.documentElement.classList.add('sl-pdp-wa');
  const h = handleOf(pf.getAttribute('data-product-url'));
  const p = C.combos[h];
  const box = document.createElement('div');
  box.className = 'slw-pdp';
  box.appendChild(waBtn(p, h, true));
  const n = document.createElement('p');
  n.className = 'slw-note';
  n.textContent = 'Los combos se piden por WhatsApp: te ayudamos a elegir colores y tallas, con envío a toda Colombia.';
  box.appendChild(n);
  host.insertAdjacentElement('beforebegin', box);
}

/* ---------- Arma tu set ---------- */
const esc = (t) => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
function groupOf(pid) {
  return (C.gr || []).find((g) => (',' + g.ids + ',').indexOf(',' + pid + ',') > -1) || null;
}
function setRoot(el) {
  return el.closest('dialog') || el.closest('.shopify-section') || document;
}
function initSet(box) {
  if (box.dataset.ready) return;
  box.dataset.ready = '1';
  const pid = box.dataset.pid;
  const g = groupOf(pid);
  /* En la compra rápida (ventana emergente) no se arma set: se compra 1 prenda con su talla */
  if (!g || box.closest('dialog, quick-add-dialog, #quick-add-modal-content')) {
    box.remove();
    return;
  }
  let cat = [];
  try {
    cat = JSON.parse(box.querySelector('script[type="application/json"]').textContent);
  } catch (x) {}
  const tiers = Object.keys(g.t)
    .map(Number)
    .sort((a, b) => a - b);
  const pre = tiers.indexOf(3) > -1 ? 3 : 1;
  const opts = [1].concat(tiers);
  let html = '<p class="sl-set__h">' + esc(box.dataset.headline || 'ARMA TU SET') + '</p><div class="sl-set__tiers" role="radiogroup">';
  opts.forEach((q) => {
    const tot = q === 1 ? g.u : g.t[q];
    const was = g.u * q;
    const save = q > 1 && was > tot ? Math.round(((was - tot) / was) * 100) : 0;
    const best = q === tiers[tiers.length - 1];
    html +=
      '<label class="sl-tier' + (q === pre ? ' is-on' : '') + '">' +
      '<input type="radio" name="sl-tier-' + pid + '" value="' + q + '"' + (q === pre ? ' checked' : '') + '>' +
      '<span class="sl-tier__t">' + (q === 1 ? 'Lleva 1 por' : 'Set por ' + q + ' unidades') +
      (save ? ' <em>Ahorra ' + save + '%</em>' : '') + (best && q > 1 ? ' <b class="sl-tier__badge">Mejor oferta</b>' : '') + '</span>' +
      '<span class="sl-tier__p"><strong>' + money(tot * 100) + '</strong>' + (save ? '<s>' + money(was * 100) + '</s>' : '') + '</span>' +
      '</label>';
  });
  html += '</div><div class="sl-set__slots"></div><p class="sl-set__msg" hidden>Elige talla para cada prenda del set.</p>';
  box.querySelector('.sl-set__ui').innerHTML = html;
  const slotsEl = box.querySelector('.sl-set__slots');

  function optVals(p, pos, prev) {
    const out = [];
    p.v.forEach((v) => {
      if (!v.a) return;
      for (let k = 0; k < pos; k++) if (v.o[k] !== prev[k]) return;
      if (v.o[pos] != null && out.indexOf(v.o[pos]) < 0) out.push(v.o[pos]);
    });
    return out;
  }
  function refreshSlot(slot) {
    const p = cat[parseInt(slot.querySelector('.sl-slot__p').value, 10) || 0];
    const prev = [];
    const wrap = slot.querySelector('.sl-slot__o');
    const keep = $$('select', wrap).map((s) => s.value);
    wrap.innerHTML = '';
    p.on.forEach((name, pos) => {
      const vals = optVals(p, pos, prev);
      const s = document.createElement('select');
      s.setAttribute('aria-label', name);
      s.innerHTML = vals.map((v) => '<option value="' + esc(v) + '">' + esc(v) + '</option>').join('');
      if (vals.indexOf(keep[pos]) > -1) s.value = keep[pos];
      prev.push(s.value);
      wrap.appendChild(s);
    });
  }
  function draw(q) {
    box.classList.toggle('is-multi', q > 1);
    setRoot(box)
      .querySelectorAll('variant-picker, .quantity-selector-wrapper')
      .forEach((el) => (q > 1 ? el.style.setProperty('display', 'none', 'important') : el.style.removeProperty('display')));
    if (q <= 1) {
      slotsEl.innerHTML = '';
      return;
    }
    const have = $$('.sl-slot', slotsEl).length;
    for (let k = have; k < q; k++) {
      const s = document.createElement('div');
      s.className = 'sl-slot';
      s.innerHTML =
        '<span class="sl-slot__n">' + (k + 1) + '</span>' +
        '<select class="sl-slot__p" aria-label="Modelo">' +
        cat.map((p, i) => '<option value="' + i + '">' + (i === 0 ? 'Este modelo' : esc(p.t)) + '</option>').join('') +
        '</select><span class="sl-slot__o"></span>';
      slotsEl.appendChild(s);
      refreshSlot(s);
    }
    $$('.sl-slot', slotsEl).forEach((s, i) => (s.style.display = i < q ? '' : 'none'));
  }
  box.addEventListener('change', (e) => {
    const t = e.target;
    if (t.name && t.name.indexOf('sl-tier-') === 0) {
      $$('.sl-tier', box).forEach((l) => l.classList.toggle('is-on', l.contains(t)));
      draw(parseInt(t.value, 10));
    } else if (t.classList.contains('sl-slot__p')) refreshSlot(t.closest('.sl-slot'));
    else if (t.closest('.sl-slot__o')) {
      const slot = t.closest('.sl-slot');
      const p = cat[parseInt(slot.querySelector('.sl-slot__p').value, 10) || 0];
      const sels = $$('.sl-slot__o select', slot);
      const idx = sels.indexOf(t);
      const prev = sels.slice(0, idx + 1).map((s) => s.value);
      sels.slice(idx + 1).forEach((s, j) => {
        const pos = idx + 1 + j;
        const vals = optVals(p, pos, prev);
        const keep = s.value;
        s.innerHTML = vals.map((v) => '<option value="' + esc(v) + '">' + esc(v) + '</option>').join('');
        if (vals.indexOf(keep) > -1) s.value = keep;
        prev.push(s.value);
      });
    }
  });
  box.slPlan = () => {
    const ck = box.querySelector('.sl-set__tiers input:checked');
    const q = ck ? parseInt(ck.value, 10) : 1;
    if (q <= 1) return null;
    const map = {};
    let bad = false;
    $$('.sl-slot', slotsEl)
      .slice(0, q)
      .forEach((s) => {
        const p = cat[parseInt(s.querySelector('.sl-slot__p').value, 10) || 0];
        const vals = $$('.sl-slot__o select', s).map((x) => x.value);
        const v = p.v.find((x) => x.a && x.o.every((o, i) => o === vals[i]));
        if (!v) {
          bad = true;
          s.classList.add('is-bad');
          return;
        }
        s.classList.remove('is-bad');
        map[v.i] = (map[v.i] || 0) + 1;
      });
    box.querySelector('.sl-set__msg').hidden = !bad;
    if (bad) return false;
    return Object.keys(map).map((id) => ({ id: Number(id), quantity: map[id] }));
  };
  draw(pre);
}
document.addEventListener(
  'click',
  async (e) => {
    const b = e.target.closest && e.target.closest('add-to-cart-component button');
    if (!b) return;
    const box = $('.sl-set', setRoot(b));
    if (!box || !box.slPlan) return;
    const plan = box.slPlan();
    if (plan === null) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (plan === false) {
      setIntent(null);
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    b.classList.add('sl-busy');
    try {
      await addLines(plan);
      openDrawer();
    } catch (err) {
      setIntent(null);
      alert(err.message || 'No se pudo agregar el set');
    } finally {
      b.classList.remove('sl-busy');
    }
  },
  true
);

/* ---------- envío: fechas en español ---------- */
function addBiz(d, n) {
  const x = new Date(d);
  while (n > 0) {
    x.setDate(x.getDate() + 1);
    if (x.getDay() !== 0) n--;
  }
  return x;
}
const MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const fd = (d) => d.getDate() + ' ' + MES[d.getMonth()];
function envio() {
  $$('.sl-envio:not([data-ok])').forEach((el) => {
    el.dataset.ok = '1';
    const now = new Date();
    const a = parseInt(el.dataset.a || '1', 10);
    const b = parseInt(el.dataset.b || '2', 10);
    const c = parseInt(el.dataset.c || '3', 10);
    const d = parseInt(el.dataset.d || '6', 10);
    const set = (k, t) => {
      const n = el.querySelector('[data-k="' + k + '"]');
      if (n) n.textContent = t;
    };
    set('1', fd(now));
    set('2', fd(addBiz(now, a)) + ' - ' + fd(addBiz(now, b)));
    set('3', fd(addBiz(now, c)) + ' - ' + fd(addBiz(now, d)));
  });
}

/* ---------- carrito: "Te recomendamos" (vacío y con productos) ---------- */
const RECO_SRC = C.recoSrc || '/collections/best-sellers/products.json?limit=12';
const RECO_MORE = C.recoMore || '/collections/shop-all';
let recoData = null;
let recoP = null;
function loadReco() {
  if (!recoP)
    recoP = fetch(RECO_SRC, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((j) => (recoData = (j.products || []).filter((p) => p.variants.some((v) => v.available))))
      .catch(() => (recoData = []));
  return recoP;
}
function recoCss() {
  if (document.getElementById('sl-reco-css')) return;
  const s = document.createElement('style');
  s.id = 'sl-reco-css';
  s.textContent =
    '.sl-reco{box-sizing:border-box;margin:18px 0 6px;padding-top:16px;border-top:1px solid var(--slp-line,#e3d8cd);text-align:left;width:100%;max-width:100%;min-width:0}' +
    '.sl-reco__t{margin:0 0 10px;font-family:var(--slp-serif,Georgia,serif);font-size:20px;font-weight:600;color:var(--slp-ink,#2e2a39)}' +
    '.sl-reco__row{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;padding-bottom:6px;scrollbar-width:thin;width:0;min-width:100%}' +
    '.sl-reco__c{flex:0 0 118px;scroll-snap-align:start;text-decoration:none;color:var(--slp-ink,#2e2a39)}' +
    '.sl-reco__c img{display:block;width:118px;aspect-ratio:3/4;object-fit:cover;border-radius:6px;background:#efe6da}' +
    '.sl-reco__n{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin:6px 0 2px;font-size:12px;line-height:1.3}' +
    '.sl-reco__p{font-size:12.5px;font-weight:600;color:var(--slp-brand,#ae7250)}' +
    '.sl-reco__p s{margin-left:5px;font-weight:400;color:var(--slp-mute,#7d7168)}' +
    '.sl-reco__more{display:flex;align-items:center;justify-content:center;margin-top:12px;min-height:42px;border:1px solid var(--slp-ink,#2e2a39);border-radius:2px;color:var(--slp-ink,#2e2a39);text-decoration:none;font-size:11.5px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;transition:background .18s,color .18s}' +
    '.sl-reco__more:hover{background:var(--slp-ink,#2e2a39);color:#fff}' +
    '.cart-items__wrapper--drawer-empty{min-width:0;max-width:100%}.cart-items__wrapper--drawer-empty .sl-reco{margin-top:28px;align-self:stretch;width:auto;padding-inline:16px}';
  document.head.appendChild(s);
}
function recos() {
  const d = document.getElementById('cart-drawer');
  if (!d) return;
  const empty = d.querySelector('.cart-items__wrapper--drawer-empty');
  const host = empty || d.querySelector('.cart-drawer__items');
  if (!host || host.querySelector('.sl-reco')) return;
  if (empty) {
    const b = empty.querySelector('.cart-items__empty-button');
    if (b) b.setAttribute('href', RECO_MORE);
  }
  if (!recoData) {
    loadReco().then(recos);
    return;
  }
  const inCart = new Set($$('a[href*="/products/"]', d).map((a) => handleOf(a.getAttribute('href'))));
  const list = recoData.filter((p) => !inCart.has(p.handle)).slice(0, 6);
  if (!list.length) return;
  recoCss();
  const cents = (x) => Math.round(parseFloat(x || 0) * 100);
  const box = document.createElement('div');
  box.className = 'sl-reco';
  box.innerHTML =
    '<p class="sl-reco__t">Te recomendamos</p><div class="sl-reco__row">' +
    list
      .map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        const im = p.images && p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
        const was = cents(v.compare_at_price) > cents(v.price) ? '<s>' + money(cents(v.compare_at_price)) + '</s>' : '';
        return (
          '<a class="sl-reco__c" href="/products/' + p.handle + '">' +
          (im ? '<img src="' + im + '" alt="' + esc(p.title) + '" loading="lazy" width="118" height="157">' : '') +
          '<span class="sl-reco__n">' + esc(p.title.split(' | ')[0]) + '</span>' +
          '<span class="sl-reco__p">' + money(cents(v.price)) + was + '</span></a>'
        );
      })
      .join('') +
    '</div><a class="sl-reco__more" href="' + RECO_MORE + '">Ver toda la tienda</a>';
  host.appendChild(box);
}

/* ---------- arranque ---------- */
function run() {
  try { cards(); } catch (x) {}
  try { forms(); } catch (x) {}
  try { $$('.sl-set').forEach(initSet); } catch (x) {}
  try { envio(); } catch (x) {}
  try { recos(); } catch (x) {}
}
run();
let mt = null;
new MutationObserver(() => {
  if (mt) return;
  mt = setTimeout(() => {
    mt = null;
    run();
  }, 120);
}).observe(document.documentElement, { childList: true, subtree: true });
